import * as React from 'react';
import { ITronLogoEvent } from '../tron-tracking/TronTrackingHandler';
import { EventEmitter } from 'events';

export interface IAppContext {
    closeApp(delay?: number): void;
    openDialog(content: any, closable?: boolean): void;
    closeDialog(): void;
    getApiKey(): string | null;
    getUserId(): string | null;
    getLogoId(): string | null;
    /**
     * Chnages user selected logo
     * @param logoId ID of new logo
     */
    onLogochanged(logoId: string): void;
    /**
     * Sets title of Tronlogo popup dialog
     * @param title title value
     */
    setTitle(title: string): void;
    /**
     * Enables / Disables closing tronlogo popup by clicking on overlay around popup window
     * @param lock true == disable close
     */
    setPopupLock(lock: boolean): void;
    /**
     * Raises Tronlogo event with given data
     * @param data Event data
     */
    raiseTronlogoEvent(data: ITronLogoEvent): void;
    /**
     * Event raised before closing tronlogo
     */
    appEvents: EventEmitter;
}

export interface IContextProps {
    appContext?: IAppContext
}

export const AppContext = React.createContext<IAppContext | null>(null);
export const AppContextProvider = AppContext.Provider;
export const AppContextConsumer = AppContext.Consumer;

// type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;
type Subtract<T, K> = Omit<T, keyof K>;

export const withAppContext = <P extends IContextProps>(
    Component: React.ComponentType<P>
) => class WithAppContext extends React.Component<Subtract<P, IContextProps>, any> {
        public render() {
            const props: any = this.props as any;
            return (
                <AppContextConsumer>
                    {value => <Component {...props} appContext={value} />}
                </AppContextConsumer>
            );
        }
    }




// WEBPACK FOOTER //
// ./src/App/shared/app-context.tsx